var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "display-4" }, [_vm._v("Welcome to Beta!")]),
      _c("p", { staticClass: "lead" }, [
        _vm._v("Web client for "),
        _c("a", { attrs: { href: "https://tavrn.gg" } }, [_vm._v("tavrn.gg")]),
        _vm._v(".")
      ]),
      _c("p", [
        _c(
          "a",
          { staticClass: "btn btn-primary btn-lg", attrs: { href: "/login" } },
          [
            _vm._v("\n      Login with tavrn.gg\n      "),
            _c("i", { staticClass: "fa fa-chevron-right" })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ff507fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff507fc","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Splash.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2ff507fc","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Splash.vue
// module chunks = 0